import React from "react"
import { useSelector } from "react-redux"

import { useAppDispatch } from "@root/store"
import { selectContactAttributes } from "@root/store/selectors"
import { removeContactAttribute, setContactAttribute } from "@root/store/thunks"
import { Attribute } from "@root/store/types"
import Attributes from "@root/components/Attributes"

const ContactAttributes: React.FC = () => {
  const attributes = useSelector(selectContactAttributes)
  const dispatch = useAppDispatch()

  const setAttribute = React.useCallback(
    (attr: Attribute) => {
      dispatch(setContactAttribute(attr))
    },
    [dispatch]
  )

  const removeAttribute = React.useCallback(
    (attr: Attribute) => {
      dispatch(removeContactAttribute(attr))
    },
    [dispatch]
  )

  return (
    <Attributes
      attributes={Object.values(attributes)}
      onSetAttribute={setAttribute}
      onRemoveAttribute={removeAttribute}
    />
  )
}

export default ContactAttributes
